const CONFIRM_PAYMENT = 'transition/confirm-payment';
const MIN_ORDER_NUMBER = 1001;

/**
 * Parse a transactions-page filter value into an order number.
 * Accepts `1401`, `#1401`, and `Order #1401`.
 * @param {string} value
 * @returns {number | null}
 */
export const parseOrderNumberInput = value => {
  const text = typeof value === 'string' ? value.trim() : '';
  const match = text.match(/^(?:order\s*)?#?(\d+)$/i);
  if (!match) {
    return null;
  }
  const orderNumber = Number(match[1]);
  if (!Number.isInteger(orderNumber)) {
    return null;
  }
  return orderNumber;
};

/**
 * Order number to display. Hidden until payment has been confirmed.
 * @param {Object} tx
 * @returns {number | null}
 */
export const orderNumberFromTransaction = tx => {
  const orderNumber = tx?.attributes?.metadata?.orderNumber;
  if (!Number.isInteger(orderNumber) || orderNumber < MIN_ORDER_NUMBER) {
    return null;
  }
  const transitions = tx?.attributes?.transitions || [];
  const paid = transitions.some(entry => entry?.transition === CONFIRM_PAYMENT);
  return paid ? orderNumber : null;
};
